import React from "react";
import injectSheet from "react-jss";
import PropTypes from "prop-types";

const styles = ({ theme }) => ({
  root: {
    margin: [15, 0],
    color: "#512b2b",
    fontFamily: theme.fonts.sans,
    fontSize: "14px"
  }
});

const DescriptionListDefinition = ({ children, classes }) => {
  return <dd className={classes.root}>{children}</dd>;
};

DescriptionListDefinition.propTypes = {
  children: PropTypes.node
};

export default injectSheet(styles, { inject: ["classes"] })(
  DescriptionListDefinition
);
